import { Pressable, View } from 'react-native';

import { Text } from '@squire/ui';

import { ChevronRightIcon } from '@/components/_icons/ChevronRightIcon';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';
import { pressedState } from '@/utils/a11y';

import { getCategoryIcon } from './categoryIcons';
import { styles } from './styles';
import type { ServiceCategoryRowProps } from './types';

const ICON_SIZE = 20;

export const ServiceCategoryRow = ({
  testID,
  name,
  libraryKey,
  count,
  hideIcon = false,
  isHighlighted = false,
  onPress,
}: ServiceCategoryRowProps) => {
  const { t } = useScreenTranslations('ServiceCategoryRow');
  const CategoryIcon = getCategoryIcon(libraryKey);

  return (
    <Pressable
      testID={testID}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={
        count === undefined ? name : `${name}, ${t('servicesCount', { count })}`
      }
      {...pressedState(isHighlighted)}
      style={[styles.row, isHighlighted && styles.rowHighlighted]}
    >
      {!hideIcon && (
        <View style={styles.iconTile}>
          <CategoryIcon size={ICON_SIZE} />
        </View>
      )}
      <View style={styles.text}>
        <Text variant="lStrong" style={styles.name} numberOfLines={1}>
          {name}
        </Text>
        {count !== undefined && (
          <Text variant="s" style={styles.count} numberOfLines={1}>
            {t('servicesCount', { count })}
          </Text>
        )}
      </View>
      <ChevronRightIcon size={16} color="iconTertiary" />
    </Pressable>
  );
};
